export default {
    me: '[Sie]',
    participate: 'evaluate now',
    status: {
        fully_evaluated: 'Fully evaluated',
        incompletely_evaluated: 'Incompletely evaluated',
        not_evaluated: 'Not evaluated',
        invalid: 'Invalid'
    }
}
